"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
exports.getReportDefinition = getReportDefinition;
exports.getAPIUrl = getAPIUrl;
exports.getEnvironment = getEnvironment;
exports.isProductionEnvironment = isProductionEnvironment;
exports.isTestEvironment = isTestEvironment;
const reportConfig_dev_json_1 = __importDefault(require("@/config/reportConfig.dev.json"));
const reportConfig_prod_json_1 = __importDefault(require("@/config/reportConfig.prod.json"));
const reportConfig_test_json_1 = __importDefault(require("@/config/reportConfig.test.json"));
const DEFAULT_API_URL = "http://localhost:8080/api";
var Environment;
(function (Environment) {
    Environment["DEV"] = "entw";
    Environment["TEST"] = "test";
    Environment["PROD"] = "echt";
})(Environment || (exports.Environment = Environment = {}));
function getReportDefinition(reportCode) {
    let reportConfig;
    const env = getEnvironment();
    if (env === Environment.PROD) {
        reportConfig = reportConfig_prod_json_1.default;
    }
    else if (env === Environment.TEST) {
        reportConfig = reportConfig_test_json_1.default;
    }
    else {
        reportConfig = reportConfig_dev_json_1.default;
    }
    if (reportConfig.reportDefinitions) {
        const foundReports = reportConfig.reportDefinitions.filter((report) => report.code === reportCode);
        if (foundReports.length > 0) {
            const reportDefinition = foundReports[0];
            if (!reportDefinition.workspaceId) {
                reportDefinition.workspaceId = reportConfig.workspaceId;
            }
            return reportDefinition;
        }
    }
    return null;
}
function getAPIUrl() {
    let apiUrl = DEFAULT_API_URL;
    if (window.AMA) {
        apiUrl = window.AMA.API_URL;
    }
    return apiUrl;
}
function getEnvironment() {
    let environment = Environment.DEV;
    const amaEnv = process.env.AMA_ENV;
    if (amaEnv) {
        // verify valid environment option
        const envList = Object.values(Environment).filter(e => e.toLowerCase() == (amaEnv === null || amaEnv === void 0 ? void 0 : amaEnv.toLowerCase()));
        if (envList.length === 1) {
            environment = envList[0];
        }
        else {
            throw new Error(`Invalid value for process.env.AMA_ENV: ${amaEnv}`);
        }
    }
    return environment;
}
function isProductionEnvironment() {
    return getEnvironment() === Environment.PROD;
}
function isTestEvironment() {
    return getEnvironment() === Environment.TEST;
}
